import React, { useState } from "react";
import "./ContactUsPage.css";
import contactUsBanner from "../assets/images/ContactUsBanner.png";
import contactUsImg from "../assets/images/ContactUsBanner2.png";

const API_URL =
  process.env.REACT_APP_API_URL || "http://localhost:4000/api/contact";

const ContactUsPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    company: "",
    mobile: "",
    email: "",
    location: "",
    description: "",
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      if (!response.ok) throw new Error("Failed to submit enquiry.");
      setSubmitted(true);
    } catch (err) {
      setError("Failed to submit enquiry. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contactus-bg">
      {/* Banner */}
      <div className="contactus-banner">
        <img
          src={contactUsBanner}
          alt="Contact Us"
          className="contactus-banner-img"
        />
      </div>

      {/* Two-column content */}
      <div className="contactus-content">
        <div className="contactus-image-col">
          <img
            src={contactUsImg}
            alt="Contact Vicon"
            className="contactus-img"
          />
        </div>

        <div className="contactus-form-panel">
          {submitted ? (
            <div className="contactus-success">
              Thank you for your enquiry!
              <br />
              Our team will connect with you shortly.
            </div>
          ) : (
            <form className="contact-form" onSubmit={handleSubmit}>
              <h2 className="contactus-form-title">Get In Touch</h2>
              <div className="contactus-form-row">
                <div className="contactus-form-col">
                  <label>
                    Name:
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </label>
                  <label>
                    Company Name:
                    <input
                      type="text"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                    />
                  </label>
                  <label>
                    Mobile Number:
                    <input
                      type="tel"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                      required
                    />
                  </label>
                </div>
                <div className="contactus-form-col">
                  <label>
                    Email ID:
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </label>
                  <label>
                    Location:
                    <input
                      type="text"
                      name="location"
                      value={formData.location}
                      onChange={handleChange}
                    />
                  </label>
                  <label>
                    Description:
                    <textarea
                      name="description"
                      value={formData.description}
                      onChange={handleChange}
                      required
                    />
                  </label>
                </div>
              </div>
              <div className="contactus-submit-row">
                <button type="submit" disabled={loading}>
                  {loading ? "Submitting..." : "Submit"}
                </button>
              </div>
              {error && <div className="contactus-error">{error}</div>}
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactUsPage;
